module.exports = __webpack_public_path__ + "img/keirin_jp.41abfc3e.png";